import { Card, CardContent } from "@/components/ui/card"
import { LucideIcon } from "lucide-react"
import { cn } from "@/lib/utils"
import { ReactNode } from "react"

interface StatCardProps {
  title: string
  value: string | number
  icon?: LucideIcon
  className?: string
  subtitle?: string
  action?: ReactNode
}

export function StatCard({ title, value, icon: Icon, className, subtitle, action }: StatCardProps) {
  return (
    <Card className={cn("p-6 card-hover animate-fade-in", className)}>
      <CardContent className="p-0">
        <div className="flex items-center justify-between">
          <div className="space-y-2 flex-1">
            <h3 className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
              {title}
              {action && action}
            </h3>
            <p className="text-2xl font-bold">{value}</p>
            {subtitle && <p className="text-xs text-muted-foreground/80">{subtitle}</p>}
          </div>
          {Icon && (
            <div className="p-3 bg-primary/10 rounded-lg hover-scale">
              <Icon className="size-6 text-primary" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
